import App from './app/App';

let app = new App();
app.addToDOM();
